export default __webpack_public_path__ + "static/media/31.31a59eed.png";